export const getAppointerSpecialties = (arrSpecialties) => {
    return Array.prototype.map.call(arrSpecialties, s => s.title).toString();
};